import { breakpoints, theme } from '@notino/react-styleguide';

import { OverflowFade } from '@components/OverflowFade';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const Wrapper = styled.div`
  margin-top: 2rem;
  @media (min-width: ${breakpoints.md}) {
    margin-top: 2.5rem;
  }
`;

export const PhotosWrapper = styled.div`
  display: flex;
  gap: 0.5rem;

  // padding at the end was ignored cuz of flexbox or smthing ... used this as workaround
  &::before,
  &::after {
    content: '';
    min-width: 0.4375rem;
  }
  @media (min-width: ${breakpoints.md}) {
    &::before,
    &::after {
      content: '';
      display: none;
    }
  }
`;

export const PhotoWrapper = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  min-width: 140px;
  height: 140px;

  > img {
    display: block;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export const PhotoOverlay = styled.div`
  text-decoration: underline;
  color: ${theme.color.text.inverse};
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: grid;
  place-items: center;
  text-align: center;
  ${theme.typography.labelRegular}
`;

export const StyledOverflowFade = styled(OverflowFade)`
  position: relative;
  left: -0.9375rem;
  width: 100vw;

  @media (min-width: ${breakpoints.md}) {
    left: 0;
    width: auto;
  }

  &::before {
    width: 80px;
    background: linear-gradient(
      270deg,
      rgba(255, 255, 255, 0) 0%,
      #ffffff 100%
    ) !important;
  }
  &::after {
    width: 80px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      #ffffff 100%
    ) !important;
  }
`;

export const customHeaderClass = css`
  box-shadow: 0px 2px 4px 0px rgba(71, 71, 71, 0.08),
    0px 1px 2px 0px rgba(71, 71, 71, 0.04);
`;
